/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who2_DescInputs */

const en_dr_who2_desc = /** @type {(inputs: Dr_Who2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite the client as a guest, no account. Their votes and rejected ideas end up recorded in the proposal — less scope creep after kickoff.`)
};

const id_dr_who2_desc = /** @type {(inputs: Dr_Who2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undang klien sebagai tamu, tanpa akun. Suara dan ide yang mereka tolak tercatat di proposal — scope creep berkurang setelah kickoff.`)
};

/**
* | output |
* | --- |
* | "Invite the client as a guest, no account. Their votes and rejected ideas end up recorded in the proposal — less scope creep after kickoff." |
*
* @param {Dr_Who2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who2_desc = /** @type {((inputs?: Dr_Who2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who2_desc(inputs)
	return en_dr_who2_desc(inputs)
});